require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardCover = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _theming = require("../../core/theming");

var _colors = require("../../styles/colors");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Card/CardCover.tsx";

var CardCover = function (_React$Component) {
  (0, _inherits2["default"])(CardCover, _React$Component);

  function CardCover() {
    (0, _classCallCheck2["default"])(this, CardCover);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CardCover).apply(this, arguments));
  }

  (0, _createClass2["default"])(CardCover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          total = _this$props.total,
          style = _this$props.style,
          theme = _this$props.theme,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["index", "total", "style", "theme"]);
      var roundness = theme.roundness;
      var coverStyle;

      if (index === 0) {
        if (total === 1) {
          coverStyle = {
            borderRadius: roundness
          };
        } else {
          coverStyle = {
            borderTopLeftRadius: roundness,
            borderTopRightRadius: roundness
          };
        }
      } else if (typeof total === 'number' && index === total - 1) {
        coverStyle = {
          borderBottomLeftRadius: roundness
        };
      }

      return React.createElement(_reactNative.View, {
        style: [styles.container, coverStyle, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69
        }
      }, React.createElement(_reactNative.Image, (0, _extends2["default"])({}, rest, {
        style: [styles.image, coverStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        }
      })));
    }
  }]);
  return CardCover;
}(React.Component);

exports.CardCover = CardCover;
(0, _defineProperty2["default"])(CardCover, "displayName", 'Card.Cover');

var styles = _reactNative.StyleSheet.create({
  container: {
    height: 195,
    backgroundColor: _colors.grey200,
    overflow: 'hidden'
  },
  image: {
    flex: 1,
    height: undefined,
    width: undefined,
    padding: 16,
    justifyContent: 'flex-end',
    resizeMode: 'cover'
  }
});

var _default = (0, _theming.withTheme)(CardCover);

exports["default"] = _default;